import { Spin, Modal } from 'antd';
import React, { useState } from 'react';
import { updateLearner } from '../../services/learnerService';
import LearnerForm from './LearnerForm';

function LearnerEdit(props) {
  const learner = props.learner;

  const initialValues = {
    email: learner.email ?? '',
    firstName: learner.firstName ?? '',
    lastName: learner.lastName ?? '',
    phoneNumber: learner.phoneNumber ?? '',
    countryId: learner.countryId ?? '',
    profileImage: learner.profileImage ?? '',
    description: learner.description ?? '',
    address: learner.address?.address ?? '',
    additionalAddress: learner.additionalAddress?.address ?? '',
    city: learner.address?.city ?? '',
    postalCode: learner.address?.postalCode ?? '',
    laptop: learner.extraInfo?.laptop?.type ?? '',
    editingSoftware: learner.extraInfo?.editingSoftware?.type ?? '',
    camera: learner.extraInfo?.camera?.type ?? '',
  };

  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode',
  });

  async function onSubmit(values) {
    setStatus({ type: 'LOADING', message: 'Request in Progress!' });
    const updatedValues = {
      email: values.email,
      firstName: values.firstName,
      lastName: values.lastName,
      phoneNumber: values.phoneNumber,
      countryId: values.countryId,
      profileImage: values.profileImage,
      description: values.description,
      address: {
        address: values.address,
        additionalAddress: values.additionalAddress,
        city: values.city,
        postalCode: values.postalCode,
      },
      extraInfo: {
        laptop: {
          type: values.laptop,
          hasItem: !!values.laptop,
        },
        editingSoftware: {
          type: values.editingSoftware,
          hasItem: !!values.editingSoftware,
        },
        camera: {
          type: values.camera,
          hasItem: !!values.camera,
        },
      },
    };

    await updateLearner(learner.learnerId, updatedValues)
      .then((response) => {
        console.log('Successfully Updated! ', response);
        props.updateLearnerData(updatedValues);
        setStatus({ type: 'SUCCESS', message: 'Data updated successfully!' });
      })
      .catch((error) => {
        alert('Getting data from the backend failed!');
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  }

  return (
    <Modal
      title={`Edit Learner: ${learner.learnerId}`}
      visible={props.isOpen}
      onCancel={() => props.toggle()}
      footer={null}
    >
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <LearnerForm
          type="Update"
          initialValues={initialValues}
          onSubmit={onSubmit}
          status={status}
        />
      )}
    </Modal>
  );
}

export default LearnerEdit;
